import Datetimepicker from './Datetimepicker';

const SELECTOR = '[data-datepicker]';

const OPTIONS = {
  allowInputToggle: true,
  viewMode: 'days',
  format: 'DD/MM/YYYY',
  extraFormats: ['YYYY-MM-DD hh:mm:ss A']
};

class Datepicker {
  constructor() {
    if ($(SELECTOR).size()) {
      this.initialize();
    }

    this.attachEventHandlers();
  }

  attachEventHandlers() {
    $('body').on('cocoon:after-insert', (event, $addedTask) => {
      if ($addedTask.find(SELECTOR).size() > 0) {
        this.initialize();
      }
    });
  }

  initialize() {
    new Datetimepicker($(SELECTOR), OPTIONS);
  }
}

export default Datepicker;



// WEBPACK FOOTER //
// ./src/javascripts/Datepicker.js